import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch details for a specific order
 * @param {number} orderId - The ID of the order to fetch
 * @returns {Promise<Object>} - Response data from the API containing order details
 */
export const getOrderDetails = async (orderId) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.ORDER.replace(':orderId', orderId)}`
    );
    return response.data.data; // Return the fetched data
  } catch (error) {
    handleApiError(error); // Handle API errors centrally
    throw error;
  }
};
